// This function allow to reference all chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if ({"vendors":1,"script_bundle":1}[chunkId]) return "public/" + chunkId + ".js";
	// return url for filenames based on template
	return chunkId + ".js";
};